<template>
    <v-card
        v-if="loading"
        class="text-center"
        style="
            display: flex;
            align-items: center;
            justify-content: center;
            min-height: 50vh;
        "
    >
        <v-progress-circular
            class="my-10 py-10"
            color="blue-lighten-3"
            indeterminate
            :size="120"
        >
            <v-img
                src="/images/d3_connect.png"
                :size="10"
                class="loading-spinner"
                :style="{
                    marginLeft: '9px',
                }"
                indeterminate
            ></v-img>
        </v-progress-circular>
    </v-card>
    <v-card v-else style="min-height: 50vh; max-height: 75vh; overflow-y: auto">
        <v-row class="info outline-text" no-gutters>
            <v-col cols="6" class="jobBarLabel">
                <v-row no-gutters class="jobBarLabel">
                    <v-col>Job #</v-col>
                </v-row>
                <v-row no-gutters class="jobBarInfo">
                    <v-col>{{ info.JobNum }}</v-col>
                </v-row>
            </v-col>
            <v-divider vertical></v-divider>
            <v-col>
                <v-row no-gutters class="jobBarLabel">
                    <v-col>ASM Seq</v-col>
                </v-row>
                <v-row no-gutters class="jobBarInfo">
                    <v-col>{{ info.AsmSeq }}</v-col>
                </v-row>
            </v-col>
            <v-divider vertical></v-divider>
            <v-col>
                <v-row no-gutters class="jobBarLabel">
                    <v-col>OPE Seq</v-col>
                </v-row>
                <v-row no-gutters class="jobBarInfo">
                    <v-col>{{ info.OprSeq }}</v-col>
                </v-row>
            </v-col>
            <v-divider vertical></v-divider>
            <v-col>
                <v-row no-gutters class="jobBarLabel">
                    <v-col>MTL #</v-col>
                </v-row>
                <v-row no-gutters class="jobBarInfo">
                    <v-col>{{ info.MtlSeq }}</v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col>
                <v-row>
                    <v-col>Part</v-col>
                </v-row>
                <div class="text-center mb-1">
                    <v-row class="boldNum">
                        <v-col>{{ info.PartNum }}</v-col>
                    </v-row>
                    <v-row>
                        <v-col>{{ info.AsmblDesc }}</v-col>
                    </v-row>
                </div>
            </v-col>
            <v-divider vertical></v-divider>
            <v-col>
                <v-row>
                    <v-col>Material</v-col>
                </v-row>
                <div class="text-center mb-1">
                    <v-row class="boldNum">
                        <v-col>{{ info.MtlNum }}</v-col>
                    </v-row>
                    <v-row>
                        <v-col>{{ info.MtlDesc }}</v-col>
                    </v-row>
                </div>
            </v-col>
        </v-row>
        <v-row class="notes pa-2" no-gutters>
            <v-col>
                <pre>{{ formatTabNotes(this.info.TabNotes) }}</pre>
            </v-col>
            <v-col v-if="this.info.Photos">
                <v-btn
                    @click="this.showPhoto = true"
                    color="#007bff"
                    style="float: right"
                    size="70"
                    class="px-16"
                >
                    <v-icon color="white" size="50"
                        >mdi mdi-image-multiple
                    </v-icon>
                </v-btn>
            </v-col>
        </v-row>
        <!--        <v-row class="text-center mb-1" no-gutters>-->
        <!--            <v-col cols="6" class="quantityNum">-->
        <!--                <div class="quantity outline-text py-1">Run Quantity</div>-->
        <!--                {{ info.RunQty }}-->
        <!--            </v-col>-->
        <!--            <v-col cols="12"></v-col>-->
        <!--            <v-divider vertical></v-divider>-->
        <!--            <v-col cols="6" class="quantityNum" style="color: #dc3545">-->
        <!--                <div class="quantity outline-text py-1">Remaining Quantity</div>-->
        <!--                {{ info.RemainingQty }}-->
        <!--            </v-col>-->
        <!--        </v-row>-->
        <v-row no-gutters>
            <v-col>
                <v-sheet>
                    <div class="quantity outline-text py-1">Run Quantity</div>
                    <div class="quantityNum">{{ info.RunQty }}</div>
                </v-sheet>
            </v-col>
            <v-col>
                <v-sheet>
                    <div class="quantity outline-text py-1">
                        Remaining Quantity
                    </div>
                    <div class="quantityNum" style="color: orangered">
                        {{ info.RemainingQty }}
                    </div>
                </v-sheet>
            </v-col>
        </v-row>
    </v-card>

    <!--PHOTO CAROUSEL-->
    <v-dialog
        v-model="showPhoto"
        max-width="50vw"
        transition="dialog-bottom-transition"
    >
        <v-card>
            <v-carousel>
                <v-carousel-item
                    v-for="(item, i) in info.Photos"
                    :key="i"
                    :src="item"
                >
                </v-carousel-item>
            </v-carousel>
        </v-card>
    </v-dialog>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
    name: "JobInfo",
    props: {
        rowID: {
            type: [String, Number],
            default: null,
        },
        job_object:{
            type: Object,
            default:{}
        },
    },

    data() {
        return {
            info: [],
            loading: false,
            showPhoto: false,
        };
    },
    mounted() {
        this.getJobInfo();
    },
    computed: {
        deptTitle() {
            let path = window.location.pathname;
            let regex = /\/labor-(\w+)\/\w+/;
            let match = path.match(regex);

            if (match && match[1]) {
                return match[1];
            }
        },

        resourceId() {
            let path = window.location.pathname;
            let regex = /\/labor-\w+\/(\w+)/;
            let match = path.match(regex);

            if (match && match[1]) {
                return match[1];
            }
        },
    },
    methods: {
        async getJobInfo() {
            if (this.rowID !== null) {
                this.loading = true;
                try {
                    await axios
                        .get(
                            route("legacy-api.getAllJobInfo", {
                                JobOperId: this.rowID, // "BE7DAF30-8A8C-46A2-AA75-43B9D0B0670B"
                                Department: this.deptTitle,
                            })
                        )
                        .then((response) => {
                            this.info = response.data[0];
                        });
                } catch (err) {
                    console.log(err);
                }
                this.loading = false;
            }
        },
        formatTabNotes(str) {
            if (str) {
                try {
                    const comments = str.split(";");
                    const formattedComments = comments
                        .filter((comment) => comment.trim().length > 0)
                        .map((comment) => {
                            const [text, author, date] = comment.split("|");
                            const formattedAuthor = author
                                ? author.replace(".", " ")
                                : "";
                            const formattedDate =
                                moment(date).format("MM/DD/YYYY HH:mm");
                            return `${text} (${formattedAuthor}, ${formattedDate})`;
                        });

                    return formattedComments.join("\n");
                } catch (e) {
                    console.error(e);
                }
            }
            return "";
        },
    },
};
</script>
<style scoped>
.info {
    background-color: #6c757d;
    text-align: center;
}

.notes {
    background-color: #fff8be;
    font-size: 0.75em;
}

.quantity {
    background-color: #007bff;
    text-align: center;
    padding: 5px;
}

.quantityNum {
    font-size: 5rem;
    font-weight: bold;
    font-family: system-ui;
    text-align: center;
}

.jobBarLabel {
    font-size: 0.75em;
}

.jobBarInfo {
    font-weight: bold;
    font-size: 1.5em;
}

.outline-text {
    color: white;
    text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000,
        1px 1px 0 #000;
}

.boldNum {
    font-weight: bold;
    font-size: 1.5em;
}
</style>
